import { inject, Injectable } from '@angular/core';
import { computed } from '@angular/core';
import { OrderApiResponseStateService } from '../../../order-api-response/order-api-response-state.service';
import { BaseWorkflowStateService } from '../../base-workflow-state.service';
import { InternetFlowStateService } from '../internet-flow-state.service';
import { InternetPackageSelectionData } from '../../../../../../../models/order/workflow/internet/internet-package-selection.model';
import { InternetProductResponseService } from '../../../order-api-response/internet-pd-response.service';



@Injectable({ providedIn: 'root' })
export class InternetPackageSelectionStateService extends BaseWorkflowStateService<InternetPackageSelectionData> {
    private orderApiResponseState: OrderApiResponseStateService = inject(OrderApiResponseStateService);
    private internetPdResponseService = inject(InternetProductResponseService);
    private flowStateService = inject(InternetFlowStateService);
    private _apiData = this.orderApiResponseState.apiData;
    protected override stateKey: string = 'internetPackageSelection';
    /** Data slice for the Order Setup step */
    internetState = this.flowStateService.state;

    /** API Data */
    apiData = computed(() => this._apiData());
    serviceAvailabilityData = this.orderApiResponseState.serviceAvailabilityData;
    customer = this.orderApiResponseState.customer;

    isPlanSelected = computed(() => !!this.state()?.selectedPlanCode);

    updateInternetProvider(value: string) {
        this.flowStateService.updateData({ provider: value });
    }

    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({ internetPackageSelection: this.state() });
    }
}
